import { render, staticRenderFns } from "./CategoryQuoteCard.vue?vue&type=template&id=235f78dd"
import script from "./CategoryQuoteCard.vue?vue&type=script&lang=js"
export * from "./CategoryQuoteCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryQuoteCard.vue?vue&type=style&index=0&id=235f78dd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports